export enum CommissionReportsGenerationStatus {
  noRooms = "no_rooms",
  notRequested = "not_requested",
  generated = "generated",
  frozen = "frozen",
  generating = "generating",
  requested = "requested",
}
